// "use client"

// import { useState, useEffect } from "react"
// import { useNavigate, useParams } from "react-router-dom"
// import { baseUrl } from "../../config/baseUrl"
// import { toast } from "react-toastify"


// const EditUser = () => {
//     const navigate = useNavigate()
//     const { id } = useParams()
//     const [formval, setFormval] = useState({
//         name: "",
//         email: "",
//         phone: "",
//         password: "",
//         role: "",
//     })
//     const [roles, setRoles] = useState([])
//     const [loading, setLoading] = useState(false)
//     const [fetchLoading, setFetchLoading] = useState(true)
//     const [errors, setErrors] = useState({})
//     const [showPassword, setShowPassword] = useState(false)

//     useEffect(() => {
//         fetchRoles()
//         fetchUserDetails()
//     }, [id])

//     const fetchRoles = async () => {
//         try {
//             const token = localStorage.getItem("token")
//             const response = await fetch(`${baseUrl}/role/role-list`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                 },
//             })
//             const data = await response.json()
//             if (data.status) {
//                 setRoles(data.data)
//             }
//         } catch (error) {
//             console.error("Error fetching roles:", error)
//         }
//     }

//     const fetchUserDetails = async () => {
//         try {
//             setFetchLoading(true)
//             const token = localStorage.getItem("token")
//             const response = await fetch(`${baseUrl}/admin-user/admin-user-detail/${id}`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                 },
//             })
//             const data = await response.json()

//             if (data.status) {
//                 setFormval({
//                     name: data.data.name || "",
//                     email: data.data.email || "",
//                     phone: data.data.phone || "",
//                     password: "",
//                     role: data.data.role?._id || data.data.role || "",
//                 })
//             } else {
//                 navigate("/admin-users")
//             }
//         } catch (error) {
//             console.error("Error fetching user details:", error)
//             navigate("/admin-users")
//         } finally {
//             setFetchLoading(false)
//         }
//     }

//     const handleChange = (e) => {
//         const { name, value } = e.target
//         setFormval((prev) => ({
//             ...prev,
//             [name]: value,
//         }))
//         // Clear error when user starts typing
//         if (errors[name]) {
//             setErrors((prev) => ({
//                 ...prev,
//                 [name]: "",
//             }))
//         }
//     }

//     const validateForm = () => {
//         const newErrors = {}

//         if (!formval.name.trim()) {
//             newErrors.name = "Name is required"
//         }

//         if (!formval.email.trim()) {
//             newErrors.email = "Email is required"
//         } else if (!/\S+@\S+\.\S+/.test(formval.email)) {
//             newErrors.email = "Invalid email format"
//         }

//         if (!formval.phone.trim()) {
//             newErrors.phone = "Phone number is required"
//         } else if (!/^\d{10}$/.test(formval.phone.replace(/\D/g, ""))) {
//             newErrors.phone = "Phone number must be 10 digits"
//         }

//         // Password is optional for edit, but if provided, validate it
//         if (formval.password && formval.password.length < 6) {
//             newErrors.password = "Password must be at least 6 characters"
//         }

//         if (!formval.role) {
//             newErrors.role = "Role is required"
//         }

//         setErrors(newErrors)
//         return Object.keys(newErrors).length === 0
//     }

//     const handleSubmit = async (e) => {
//         e.preventDefault()

//         if (!validateForm()) {
//             return
//         }

//         setLoading(true)

//         try {
//             const token = localStorage.getItem("token")

//             // Only include password in update if it's been changed
//             const updateData = { ...formval }
//             if (!updateData.password) {
//                 delete updateData.password
//             }

//             const response = await fetch(`${baseUrl}/admin-user/admin-user-update/${id}`, {
//                 method: "PUT",
//                 headers: {
//                     "Content-Type": "application/json",
//                     Authorization: `Bearer ${token}`,
//                 },
//                 body: JSON.stringify(updateData),
//             })

//             const data = await response.json()

//             if (data.status) {
//                 toast.success("User updated successfully!")
//                 navigate("/admin-users")
//             } else {
//                 toast.error(data.message || "Failed to update user")
//             }
//         } catch (error) {
//             console.error("Error updating user:", error)
//         } finally {
//             setLoading(false)
//         }
//     }

//     if (fetchLoading) {
//         return (
//             <div className="container-fluid py-4">
//                 <div className="row justify-content-center">
//                     <div className="col-lg-8 col-xl-7">
//                         <div className="text-center py-5">
//                             <div className="spinner-border text-primary" role="status">
//                                 <span className="visually-hidden">Loading...</span>
//                             </div>
//                             <p className="text-muted mt-3">Loading user details...</p>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         )
//     }

//     return (
//         <div className="main-sec ">
//             <div className="row justify-content-center">
//                 <div className="col-lg-8 col-xl-7">
//                     {/* Header */}
//                     <div className="d-flex align-items-center mb-4">
//                         <button
//                             onClick={() => navigate("/admin-users")}
//                             className="btn btn-light me-3"
//                             style={{
//                                 width: "40px",
//                                 height: "40px",
//                                 borderRadius: "10px",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "center",
//                                 border: "1px solid #e5e7eb",
//                             }}
//                         >
//                             <i className="fas fa-arrow-left"></i>
//                         </button>
//                         <div>
//                             <h3 className="mb-1 fw-bold" style={{ color: "#1f2937" }}>
//                                 Edit User
//                             </h3>
//                             <p className="text-muted mb-0">Update user account details and role assignment</p>
//                         </div>
//                     </div>

//                     {/* Form Card */}
//                     <div
//                         className="card border-0 shadow-sm"
//                         style={{
//                             borderRadius: "16px",
//                             background: "#ffffff",
//                         }}
//                     >
//                         <div className="card-body p-4 p-md-5">
//                             <form onSubmit={handleSubmit}>
//                                 {/* Name Field */}
//                                 <div className="mb-4">
//                                     <label
//                                         htmlFor="name"
//                                         className="form-label fw-semibold"
//                                         style={{ color: "#374151", fontSize: "14px" }}
//                                     >
//                                         Full Name <span className="text-danger">*</span>
//                                     </label>
//                                     <input
//                                         type="text"
//                                         className={`form-control ${errors.name ? "is-invalid" : ""}`}
//                                         id="name"
//                                         name="name"
//                                         value={formval.name}
//                                         onChange={handleChange}
//                                         placeholder="Enter full name"
//                                         style={{
//                                             height: "48px",
//                                             borderRadius: "10px",
//                                             border: "1px solid #e5e7eb",
//                                             fontSize: "15px",
//                                         }}
//                                     />
//                                     {errors.name && <div className="invalid-feedback">{errors.name}</div>}
//                                 </div>

//                                 {/* Email Field */}
//                                 <div className="mb-4">
//                                     <label
//                                         htmlFor="email"
//                                         className="form-label fw-semibold"
//                                         style={{ color: "#374151", fontSize: "14px" }}
//                                     >
//                                         Email Address <span className="text-danger">*</span>
//                                     </label>
//                                     <input
//                                         type="email"
//                                         className={`form-control ${errors.email ? "is-invalid" : ""}`}
//                                         id="email"
//                                         name="email"
//                                         value={formval.email}
//                                         onChange={handleChange}
//                                         placeholder="Enter email address"
//                                         style={{
//                                             height: "48px",
//                                             borderRadius: "10px",
//                                             border: "1px solid #e5e7eb",
//                                             fontSize: "15px",
//                                         }}
//                                     />
//                                     {errors.email && <div className="invalid-feedback">{errors.email}</div>}
//                                 </div>

//                                 {/* Phone Field */}
//                                 <div className="mb-4">
//                                     <label
//                                         htmlFor="phone"
//                                         className="form-label fw-semibold"
//                                         style={{ color: "#374151", fontSize: "14px" }}
//                                     >
//                                         Phone Number <span className="text-danger">*</span>
//                                     </label>
//                                     <input
//                                         type="tel"
//                                         className={`form-control ${errors.phone ? "is-invalid" : ""}`}
//                                         id="phone"
//                                         name="phone"
//                                         value={formval.phone}
//                                         onChange={handleChange}
//                                         placeholder="Enter phone number"
//                                         style={{
//                                             height: "48px",
//                                             borderRadius: "10px",
//                                             border: "1px solid #e5e7eb",
//                                             fontSize: "15px",
//                                         }}
//                                     />
//                                     {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
//                                 </div>

//                                 {/* Password Field */}
//                                 <div className="mb-4">
//                                     <label
//                                         htmlFor="password"
//                                         className="form-label fw-semibold"
//                                         style={{ color: "#374151", fontSize: "14px" }}
//                                     >
//                                         Password <span className="text-muted">(Leave blank to keep current password)</span>
//                                     </label>
//                                     <div className="position-relative">
//                                         <input
//                                             type={showPassword ? "text" : "password"}
//                                             className={`form-control ${errors.password ? "is-invalid" : ""}`}
//                                             id="password"
//                                             name="password"
//                                             value={formval.password}
//                                             onChange={handleChange}
//                                             placeholder="Enter new password (optional)"
//                                             style={{
//                                                 height: "48px",
//                                                 borderRadius: "10px",
//                                                 border: "1px solid #e5e7eb",
//                                                 fontSize: "15px",
//                                                 paddingRight: "45px",
//                                             }}
//                                         />
//                                         <button
//                                             type="button"
//                                             onClick={() => setShowPassword(!showPassword)}
//                                             className="btn btn-link position-absolute"
//                                             style={{
//                                                 right: "8px",
//                                                 top: "50%",
//                                                 transform: "translateY(-50%)",
//                                                 color: "#6b7280",
//                                             }}
//                                         >
//                                             <i className={`fas fa-eye${showPassword ? "-slash" : ""}`}></i>
//                                         </button>
//                                         {errors.password && <div className="invalid-feedback">{errors.password}</div>}
//                                     </div>
//                                     <small className="text-muted">Password must be at least 6 characters long if changing</small>
//                                 </div>

//                                 {/* Role Field */}
//                                 <div className="mb-5">
//                                     <label
//                                         htmlFor="role"
//                                         className="form-label fw-semibold"
//                                         style={{ color: "#374151", fontSize: "14px" }}
//                                     >
//                                         Role <span className="text-danger">*</span>
//                                     </label>
//                                     <select
//                                         className={`form-select ${errors.role ? "is-invalid" : ""}`}
//                                         id="role"
//                                         name="role"
//                                         value={formval.role}
//                                         onChange={handleChange}
//                                         style={{
//                                             height: "48px",
//                                             borderRadius: "10px",
//                                             border: "1px solid #e5e7eb",
//                                             fontSize: "15px",
//                                         }}
//                                     >
//                                         <option value="">Select a role</option>
//                                         {roles.map((role) => (
//                                             <option key={role._id} value={role._id}>
//                                                 {role.name}
//                                             </option>
//                                         ))}
//                                     </select>
//                                     {errors.role && <div className="invalid-feedback">{errors.role}</div>}
//                                 </div>

//                                 {/* Action Buttons */}
//                                 <div className="d-flex gap-3">
//                                     <button
//                                         type="button"
//                                         onClick={() => navigate("/admin-users")}
//                                         className="btn btn-light flex-fill"
//                                         style={{
//                                             height: "48px",
//                                             borderRadius: "10px",
//                                             border: "1px solid #e5e7eb",
//                                             fontSize: "15px",
//                                             fontWeight: "500",
//                                         }}
//                                     >
//                                         Cancel
//                                     </button>
//                                     <button
//                                         type="submit"
//                                         disabled={loading}
//                                         className="btn flex-fill"
//                                         style={{
//                                             height: "48px",
//                                             borderRadius: "10px",
//                                             fontSize: "15px",
//                                             fontWeight: "500",
//                                             background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                                             border: "none",
//                                             color: "white",
//                                         }}
//                                     >
//                                         {loading ? (
//                                             <>
//                                                 <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
//                                                 Updating...
//                                             </>
//                                         ) : (
//                                             <>
//                                                 <i className="fas fa-save me-2"></i>
//                                                 Update User
//                                             </>
//                                         )}
//                                     </button>
//                                 </div>
//                             </form>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default EditUser



"use client"

import { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { baseUrl } from "../../config/baseUrl"
import { toast } from "react-toastify"

const EditUser = () => {
    const navigate = useNavigate()
    const { id } = useParams()
    const [formval, setFormval] = useState({
        name: "",
        email: "",
        phone: "",
        password: "",
        role: "",
    })
    const [roles, setRoles] = useState([])
    const [loading, setLoading] = useState(false)
    const [fetchLoading, setFetchLoading] = useState(true)
    const [errors, setErrors] = useState({})
    const [showPassword, setShowPassword] = useState(false)

    useEffect(() => {
        fetchRoles()
        fetchUserDetails()
    }, [id])

    const fetchRoles = async () => {
        try {
            const token = localStorage.getItem("token")
            const response = await fetch(`${baseUrl}/role/role-list`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            const data = await response.json()
            if (data.status) {
                setRoles(data.data)
            }
        } catch (error) {
            console.error("Error fetching roles:", error)
        }
    }

    const fetchUserDetails = async () => {
        try {
            setFetchLoading(true)
            const token = localStorage.getItem("token")
            const response = await fetch(`${baseUrl}/admin-user/admin-user-detail/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            const data = await response.json()

            if (data.status) {
                setFormval({
                    name: data.data.name || "",
                    email: data.data.email || "",
                    phone: data.data.phone || "",
                    password: "",
                    role: data.data.role?._id || data.data.role || "",
                })
            } else {
                navigate("/admin-users")
            }
        } catch (error) {
            console.error("Error fetching user details:", error)
            navigate("/admin-users")
        } finally {
            setFetchLoading(false)
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target
        setFormval((prev) => ({
            ...prev,
            [name]: value,
        }))
        // Clear error when user starts typing
        if (errors[name]) {
            setErrors((prev) => ({
                ...prev,
                [name]: "",
            }))
        }
    }

    const validateForm = () => {
        const newErrors = {}

        if (!formval.name.trim()) {
            newErrors.name = "Name is required"
        }

        if (!formval.email.trim()) {
            newErrors.email = "Email is required"
        } else if (!/\S+@\S+\.\S+/.test(formval.email)) {
            newErrors.email = "Invalid email format"
        }

        if (!formval.phone.trim()) {
            newErrors.phone = "Phone number is required"
        } else if (!/^\d{10}$/.test(formval.phone.replace(/\D/g, ""))) {
            newErrors.phone = "Phone number must be 10 digits"
        }

        // Password is optional for edit, but if provided, validate it
        if (formval.password && formval.password.length < 6) {
            newErrors.password = "Password must be at least 6 characters"
        }

        if (!formval.role) {
            newErrors.role = "Role is required"
        }

        setErrors(newErrors)
        return Object.keys(newErrors).length === 0
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (!validateForm()) {
            return
        }

        setLoading(true)

        try {
            const token = localStorage.getItem("token")

            // Only include password in update if it's been changed
            const updateData = { ...formval }
            if (!updateData.password) {
                delete updateData.password
            }

            const response = await fetch(`${baseUrl}/admin-user/admin-user-update/${id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(updateData),
            })

            const data = await response.json()

            if (data.status) {
                toast.success("User updated successfully!")
                navigate("/admin-users")
            } else {
                toast.error(data.message || "Failed to update user")
            }
        } catch (error) {
            console.error("Error updating user:", error)
        } finally {
            setLoading(false)
        }
    }

    if (fetchLoading) {
        return (
            <div className="container-fluid py-4">
                <div className="row justify-content-center">
                    <div className="col-lg-8 col-xl-7">
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className="text-muted mt-3">Loading user details...</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="main-sec ">
            <div className="row justify-content-center">
                <div className="col-lg-8 col-xl-7">
                    {/* Header */}
                    <div className="d-flex align-items-center mb-4">
                        <button
                            onClick={() => navigate("/admin-users")}
                            className="btn btn-light me-3"
                            style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "10px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                border: "1px solid #e5e7eb",
                            }}
                        >
                            <i className="fas fa-arrow-left"></i>
                        </button>
                        <div>
                            <h3 className="mb-1 fw-bold" style={{ color: "#1f2937" }}>
                                Edit User
                            </h3>
                            <p className="text-muted mb-0">Update user account details and role assignment</p>
                        </div>
                    </div>

                    {/* Form Card */}
                    <div
                        className="card border-0 shadow-sm"
                        style={{
                            borderRadius: "16px",
                            background: "#ffffff",
                        }}
                    >
                        <div className="card-body p-4 p-md-5">
                            <form onSubmit={handleSubmit}>
                                {/* Name Field */}
                                <div className="mb-4">
                                    <label
                                        htmlFor="name"
                                        className="form-label fw-semibold"
                                        style={{ color: "#374151", fontSize: "14px" }}
                                    >
                                        Full Name <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.name ? "is-invalid" : ""}`}
                                        id="name"
                                        name="name"
                                        value={formval.name}
                                        onChange={handleChange}
                                        placeholder="Enter full name"
                                        style={{
                                            height: "48px",
                                            borderRadius: "10px",
                                            border: "1px solid #e5e7eb",
                                            fontSize: "15px",
                                        }}
                                    />
                                    {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                                </div>

                                {/* Email Field */}
                                <div className="mb-4">
                                    <label
                                        htmlFor="email"
                                        className="form-label fw-semibold"
                                        style={{ color: "#374151", fontSize: "14px" }}
                                    >
                                        Email Address <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="email"
                                        className={`form-control ${errors.email ? "is-invalid" : ""}`}
                                        id="email"
                                        name="email"
                                        value={formval.email}
                                        onChange={handleChange}
                                        placeholder="Enter email address"
                                        style={{
                                            height: "48px",
                                            borderRadius: "10px",
                                            border: "1px solid #e5e7eb",
                                            fontSize: "15px",
                                        }}
                                    />
                                    {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                                </div>

                                {/* Phone Field */}
                                <div className="mb-4">
                                    <label
                                        htmlFor="phone"
                                        className="form-label fw-semibold"
                                        style={{ color: "#374151", fontSize: "14px" }}
                                    >
                                        Phone Number <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="tel"
                                        className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                                        id="phone"
                                        name="phone"
                                        value={formval.phone}
                                        onChange={handleChange}
                                        placeholder="Enter phone number"
                                        style={{
                                            height: "48px",
                                            borderRadius: "10px",
                                            border: "1px solid #e5e7eb",
                                            fontSize: "15px",
                                        }}
                                    />
                                    {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
                                </div>

                                {/* Password Field */}
                                <div className="mb-4">
                                    <label
                                        htmlFor="password"
                                        className="form-label fw-semibold"
                                        style={{ color: "#374151", fontSize: "14px" }}
                                    >
                                        Password <span className="text-muted">(Leave blank to keep current password)</span>
                                    </label>
                                    <div className="position-relative">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            className={`form-control ${errors.password ? "is-invalid" : ""}`}
                                            id="password"
                                            name="password"
                                            value={formval.password}
                                            onChange={handleChange}
                                            placeholder="Enter new password (optional)"
                                            style={{
                                                height: "48px",
                                                borderRadius: "10px",
                                                border: "1px solid #e5e7eb",
                                                fontSize: "15px",
                                                paddingRight: "45px",
                                            }}
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowPassword(!showPassword)}
                                            className="btn btn-link position-absolute"
                                            style={{
                                                right: "8px",
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                color: "#6b7280",
                                            }}
                                        >
                                            <i className={`fas fa-eye${showPassword ? "-slash" : ""}`}></i>
                                        </button>
                                        {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                                    </div>
                                    <small className="text-muted">Password must be at least 6 characters long if changing</small>
                                </div>

                                {/* Role Field */}
                                <div className="mb-5">
                                    <label
                                        htmlFor="role"
                                        className="form-label fw-semibold"
                                        style={{ color: "#374151", fontSize: "14px" }}
                                    >
                                        Role <span className="text-danger">*</span>
                                    </label>
                                    <select
                                        className={`form-select ${errors.role ? "is-invalid" : ""}`}
                                        id="role"
                                        name="role"
                                        value={formval.role}
                                        onChange={handleChange}
                                        style={{
                                            height: "48px",
                                            borderRadius: "10px",
                                            border: "1px solid #e5e7eb",
                                            fontSize: "15px",
                                        }}
                                    >
                                        <option value="">Select a role</option>
                                        {roles.map((role) => (
                                            <option key={role._id} value={role._id}>
                                                {role.name}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.role && <div className="invalid-feedback">{errors.role}</div>}
                                </div>

                                {/* Action Buttons */}
                                <div className="d-flex gap-3">
                                    <button
                                        type="button"
                                        onClick={() => navigate("/admin-users")}
                                        className="btn btn-light flex-fill"
                                        style={{
                                            height: "48px",
                                            borderRadius: "10px",
                                            border: "1px solid #e5e7eb",
                                            fontSize: "15px",
                                            fontWeight: "500",
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        disabled={loading}
                                        className="btn flex-fill"
                                        style={{
                                            height: "48px",
                                            borderRadius: "10px",
                                            fontSize: "15px",
                                            fontWeight: "500",
                                            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                            border: "none",
                                            color: "white",
                                        }}
                                    >
                                        {loading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Updating...
                                            </>
                                        ) : (
                                            <>
                                                <i className="fas fa-save me-2"></i>
                                                Update User
                                            </>
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EditUser
